import { getSalesMetros, listSalesMetrosForManagement } from './GetSalesMetros';
import { findSalesMetroByZip } from './FindSalesMetroByZip';
import { getSalesMetroZips } from './GetSalesMetroZips';
import { setSalesMetroAdmins } from './SetSalesMetroAdmins';

/**
 * Sales Metros Service
 * Provides business logic layer for sales metro operations
 */
export const SalesMetrosService = {
  getSalesMetros,
  listSalesMetrosForManagement,
  findSalesMetroByZip,
  getSalesMetroZips,
  setSalesMetroAdmins,
};
